import searchImg from "@assets/header/search.svg";
import Close from "@assets/search/close.svg?react";
import React, { useState } from "react";

import Button from "../Button/Button";

interface SearchOverlayProps {
  onSearch: (query: string) => void;
  setOverlay: () => void;
  isVisible: boolean;
}

const SearchOverlay: React.FC<SearchOverlayProps> = ({
  onSearch,
  setOverlay,
  isVisible,
}) => {
  const [searchQuery, setSearchQuery] = useState<string>(""); // 存储搜索框内容

  // 搜索事件处理
  const handleSearch = () => {
    onSearch(searchQuery); // 调用父组件传递的搜索函数
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onSearch(searchQuery);
    }
  };

  return (
    <div
      className={`fixed inset-0 z-[999999] flex items-center justify-center overflow-hidden bg-secondary transition-transform duration-500 ease-in-out ${isVisible ? "translate-x-0" : "-translate-x-full"}`}
      data-testid="redants-search"
    >
      <button
        aria-label="close"
        onClick={setOverlay}
        className="absolute top-0 box-border flex w-full cursor-pointer justify-end p-[16px] text-right text-2xl text-gray-600"
      >
        <div className="box-content rounded-full p-[8px] lg:hover:!bg-button-ghost">
          <Close className="size-[24px]" />
        </div>
      </button>
      <div className="box-border flex w-full justify-center p-[16px]">
        <div className="box-content flex h-[40px] w-full border-b border-solid border-b-[divide-divider-primary] p-[10px]  lg:w-[756px]">
          <input
            type="text"
            placeholder="想找些什么？"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
            onKeyDown={handleKeyDown}
            className="w-full bg-secondary text-header-1 text-primary placeholder:text-secondary focus:outline-none focus:ring-0"
          />
          <Button
            variant="ghost"
            onClick={handleSearch}
            className="!h-[40px] !w-[40px] shrink-0 rounded-full !p-0 lg:hover:bg-button-ghost"
          >
            <img src={searchImg} alt="search" className="size-[40px] p-[8px]" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchOverlay;
